// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX
import * as React from 'react';
import * as ReactDom from 'react-dom';
import * as _ from 'lodash';
import { Filter } from './filter';
import { IFilterType } from './objects/iFilterType';
import { ISearchFacet } from './objects/iSearchFacet';
import { updateFacet } from './actions/app-actions';
import find = require('lodash/find');

interface IFilterListProps {
	filters: Array<IFilterType>,
	dispatch: any,
	onChange: Function,
    searchFacets: ISearchFacet[],
    
}

interface IFilterListState {
    displayFilterBy: boolean
}

export class FilterList extends React.Component<IFilterListProps, IFilterListState> {
    constructor(props) {
        super(props);
        this.shouldDisplayFilterBy = this.shouldDisplayFilterBy.bind(this);
        this.state = {
            displayFilterBy: false
        }
    }

    shouldDisplayFilterBy(display) {
        this.setState({
            displayFilterBy: display
        })
    }

	render() {
		return (
            <section className="sidebar-filters">
                {this.state.displayFilterBy ? <h2>Filter By</h2> : ''}
					{this._getAppliedFilters()}
                    {this.props.filters.map((filter, i) => <Filter key={i} SectionIndex={i} dispatch={this.props.dispatch} {...filter}
                    onChange={this.props.onChange} facet={this._getFilterFacet(filter)} usingChecks={i == 0 ? false : true} listDisplayFilterBy={this.shouldDisplayFilterBy} />)}
			</section>
		);
	}

	_getFilterFacet(filter: IFilterType): ISearchFacet {
        let facet = find(this.props.searchFacets, ((facet) => facet.facet == filter.Name));
		return facet;
	}

	_getAppliedFilters() {
		let filters = this.props.searchFacets;
		let appliedFilters = _.flatten(filters.map((filter) => {
			if (filter.facet != 'Keyword')
				return filter.search;
			return [];
		}));
        return <div>
                {appliedFilters.length > 0 ? "You've selected:" : ""}
				{appliedFilters.map((filterName, i) => {
					return <div className="sidebar-filters-selected" key={i}>{filterName.Text}<button aria-label="Close" onClick={this._removeAppliedFilter.bind(this, filterName)}>X</button></div>
			})}
		</div>
	}

	_removeAppliedFilter(filterName, event) {
		event.preventDefault();
		let filters = this.props.searchFacets;
		let didRemoval = false;
		_.each(filters, (facet) => {
			if (facet.facet != 'Keyword') {
				_.remove(facet.search, (facetName) => {
					if (facetName == filterName) {
						didRemoval = true;
						return true;
					}
					return false;
				});
				if (didRemoval) {
					this.props.dispatch(updateFacet(facet.facet, facet.search));
				}
			}
		});
		if (didRemoval) {
			if (typeof (this.props.onChange) === 'function') {
				this.props.onChange();
			}
		}
    }
}
